<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Integrations"
};
</script>

<style lang="scss" scoped></style>
